import React from 'react'
import ExhibitorsWithProfessions from './ExhibitorsWithProfessions'
import ProfessionsWithExhibitors from './ProfessionsWithExhibitors'
import ProfessionsByTheme from './ProfessionsByTheme'
import TypeFilteredExhibitors from './TypeFilteredExhibitors'
import InternshipExhibitors from './InternshipExhibitors'
import MatchMeista from './MatchMeista'
import { tilePath } from '../../functions/tilePath'

// tiles[].type ist der Schlüssel auf die Abschnittskomponente (Spec Kachel-
// steuerung §3). Die Zuordnung ist die eine Quelle für Kachelseite
// (EventSection) und Shortcode (#177). Die Ausstellerkarte verlinkt ihre
// Berufe in die Themen-Kachel derselben Messe; deren Slug kennt nur das
// Event, darum reicht der Abschnitt ihn weiter (#53).
const SECTIONS = {
    exhibitors: ({ data, event, LinkComponent }) => <ExhibitorsWithProfessions data={data} themesPath={tilePath(event, 'themes')} LinkComponent={LinkComponent} />,
    professions: ({ data }) => <ProfessionsWithExhibitors data={data} />,
    themes: ({ data }) => <ProfessionsByTheme data={data} />,
    internships: ({ data }) => <InternshipExhibitors data={data} />,
    dualStudies: ({ data, event, LinkComponent }) => <TypeFilteredExhibitors data={data} types={['Duales Studium', 'Studium']} themesPath={tilePath(event, 'themes')} LinkComponent={LinkComponent} />,
    matchmeista: ({ event }) => <MatchMeista mappingId={event.matchMeistaMappingId} />
}

export const sectionForType = (type) => SECTIONS[type] || null

// Die Abschnitte, die der Shortcode anbietet: nur die datengetriebenen.
// MatchMeista hat [shortcode_matrix], freetext/wpPage leben von ihrer Kachel.
export const SHORTCODE_TYPES = ['exhibitors', 'professions', 'themes', 'internships', 'dualStudies']
